import {Form} from "../form/form.js";

export class FormInputText extends Form{
    ready(){
        super.ready();
        this.findMember("send").on(
            "click",
            (ev)=>{
                ev.preventDefault();
                debugger;
                let res = document.getElementById('requiredText').value
                if(res){
                    let txt = document.getElementById('m').value
                    if(txt.length<20){
                        alert("Almenos debe tener 20 carácteres")
                    }else{
                        document.getElementById('a').value = new URLSearchParams(window.location.search).get('a');
                        this.findMember("form-input-text").submit();
                    }
                }else{
                    console.log("False")
                    document.getElementById('a').value = new URLSearchParams(window.location.search).get('a');
                    this.findMember("form-input-text").submit();
                }
            }
        );

        var param_m = new URLSearchParams(window.location.search).get('m');
        if(param_m || param_m.length < 1 ){
            document.getElementById('redirect-link').click();
        }
    }
}